import { ErrorBoundary } from '@sentry/react';
import { Gender } from '@statsbomb/parachute-types';
import { useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { genderAtom } from '@/atoms/queries/userConfigs';
import { SwitchToClassicButton } from './SwitchToClassicButton';

const SwitchToClassicPlayerScoutButtonBase = ({ gender }: { gender: Gender | undefined }) => {
  const isMen = gender === Gender.M;
  const pathGender = isMen ? 'men' : 'women';

  return (
    <SwitchToClassicButton
      path={`scout/search/${pathGender}`}
      navOverrides={{
        playerScout: true,
      }}
    />
  );
};

const SwitchToClassicPlayerScoutButtonWithData = () => {
  const gender = useAtomValue(genderAtom);
  return <SwitchToClassicPlayerScoutButtonBase gender={gender} />;
};

export const SwitchToClassicPlayerScoutButton = () => (
  <ErrorBoundary fallback={<SwitchToClassicPlayerScoutButtonBase gender={Gender.M} />}>
    <Suspense fallback={<SwitchToClassicPlayerScoutButtonBase gender={Gender.M} />}>
      <SwitchToClassicPlayerScoutButtonWithData />
    </Suspense>
  </ErrorBoundary>
);
